/**
 * Regroupe des items par section, dans l'ordre visuel défini.
 * Les sections sans item visible sont omises.
 *
 * @param {Array<{ id: string, title?: string | null }>} sectionDefs
 * @param {Record<string, string[]>} sectionItemOrder
 * @param {Record<string, object>} itemsById
 * @returns {Array<{ id: string, title?: string | null, items: object[] }>}
 */
export function groupNavigation(sectionDefs, sectionItemOrder, itemsById) {
  return sectionDefs
    .map((section) => ({
      ...section,
      items: (sectionItemOrder[section.id] || [])
        .map((itemId) => itemsById[itemId])
        .filter(Boolean),
    }))
    .filter((section) => section.items.length > 0);
}
